<template>
  <div id="family-memberlist">
    <ul>
      <li class="member"
        v-for="(item, index) in familyMemberList" :key="index">
        <div class="head">{{item.role_label}}</div>
        <img class="avatar" :src="require(`@/assets/images/personal/${avatarFomatter(item.role)}.png`)" >
        <span class="name">{{item.real_name}}</span>
        <div class="btns">
          <button @click="edit(item.id)">编辑</button>
          <button @click="deleteMember(item.id)">删除</button>
        </div>
      </li>
      <li class="add" @click="addFamilyMember">
        <img src="@/assets/images/common/add.png" alt="">
        <span>添加</span>
      </li>
    </ul>
  </div>
</template>

<script>
// 家庭成员列表
export default {
  name: 'familyMemberList',
  data() {
    return {
      familyMemberList:[]
    }
  },
  methods: {
    // 获取家庭成员列表
    getFamilyMemberList(){
      this.axios({
        method: 'GET',
        url: '/user-family?need=id,role,role_label,real_name',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        console.log('FamilyMemberList')
        console.log(res)
        if(res.data.code == 0){
          this.familyMemberList = res.data.data
        }
      })
    },
    // 头像名称设置
    avatarFomatter(role){
      switch (role){
        case 1:
          return this.Storage.get('userBaseInfo').gender == 1 ? 'male' : 'female'
        case 2:
          return this.Storage.get('userBaseInfo').gender == 1 ? 'female' : 'male'
        case 3:
          return 'son'
        case 4:
          return 'daughter'
        case 5:
          return 'father'
        case 6:
          return 'mother'
        case 7:
          return 'father'
        case 8:
          return 'mother'
        default:
          return `other`
      }
    },
    // 删除成员
    deleteMember(id){
      this.$dialog.confirm({
        message: '确认要删除该家庭成员吗？',
      }).then(() => {
        this.axios({
          method: 'DELETE',
          url: `/user-family/${id}`,
          headers: {
            'Authorization': `Bearer ${this.Global.getCookie('token')}` 
          }
        }).then((res) => {
          if(res.data.code == 0){
            this.familyMemberList = res.data.data
            this.$toast('删除成功')
          }
        })
      })
    },
    // 编辑成员信息
    edit(memberId){
      this.$router.push({
        path:'/memberInfo',
        query: {
          memberId,
          from: '/familyMemberList'
        }
      })
    },
    // 添加成员
    addFamilyMember(){
      this.$router.push({
        path:'/memberInfo',
        query: {
          from: '/familyMemberList'
        }
      })
    }
  },
  created(){
    this.getFamilyMemberList()
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
  ul{
    display: flex;
    flex-wrap: wrap;
    padding: 0 1.28125rem 1.25rem;
  }
  ul li{
    width: 8.375rem;
    height: 11.6875rem;
    border-radius: 0.3125rem;
    margin: 1.25rem 1.03125rem 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  ul li.member{
    border: 1px solid rgba(255,161,39,1);
    position: relative;
  }
  ul li.member .head{
    text-align: center;
    color: #FFF;
    background: rgba(255,161,39,1);
    width: 100%;
    height: 2.1875rem;
    line-height: 2.1875rem;
    font-size: 1.0625rem;
    font-weight: 500;
  }
  ul li.member .avatar{
    width: 3.875rem;
    height: 3.875rem;
    border-radius: 0.3125rem;
    margin-top: 0.9375rem;
  }
  ul li.member .name{
    font-size: 0.9375rem;
    color: #4D4D4D;
    font-weight: 500;
    margin: 0.625rem 0 0;
  }
  ul li.member .btns{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0.75rem;
  }
  ul li.member .btns button{
    width: 3rem;
    height: 1.375rem;
    /* line-height: 21px; */
    /* text-align: center; */
    border: 1px solid;
    font-size: 0.875rem;
    font-weight: 400;
    background: #FFF;
    margin: 0 0.3125rem;
    border-radius: 0.1875rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ul li.member .btns button:first-child{
    color: rgba(255,161,39,1);
  }
  ul li.member .btns button:last-child{
    color: #999;
  }

  ul li.add{
    background: #F1EEEA;
    justify-content: center;  
  }
  ul li.add img{
    width: 2.9375rem;
  }
  ul li.add span{
    font-size:0.9375rem;
    font-weight:500;
    color: rgba(130, 130, 130, 0.87);
    margin-top: 1.3125rem;
  }
</style>